import { render, staticRenderFns } from "./develop.vue?vue&type=template&id=1292fbfa&scoped=true&"
import script from "./develop.vue?vue&type=script&lang=js&"
export * from "./develop.vue?vue&type=script&lang=js&"
import style0 from "./develop.vue?vue&type=style&index=0&id=1292fbfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1292fbfa",
  null
  
)

export default component.exports